import React from "react";

export default function AssociationsSkeleton() {
  return (
    <div className="grid gap-5 lg:grid-cols-2">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950"
        >
          <div className="h-2 bg-slate-200 dark:bg-slate-800" />

          <div className="flex flex-col gap-5 p-5 sm:flex-row sm:p-6">
            <div className="h-28 w-28 animate-pulse rounded-3xl bg-slate-200 dark:bg-slate-800 sm:h-32 sm:w-32" />

            <div className="flex-1 space-y-4">
              <div className="h-5 w-28 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="h-7 w-2/3 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="space-y-2">
                <div className="h-4 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
                <div className="h-4 w-11/12 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
                <div className="h-4 w-8/12 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              </div>
              <div className="h-20 animate-pulse rounded-3xl bg-slate-100 dark:bg-slate-900" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}